// extracted by mini-css-extract-plugin
module.exports = {"Governance":"governanceAndManagement_Governance__1dgOe","Title":"governanceAndManagement_Title__m4uPm","ActionBar":"governanceAndManagement_ActionBar__1_3jR"};